/*global Vue*/
import Vue from 'vue';
import 'vue-material/dist/vue-material.css';
require('./less/style.less');
var theme = require('./theme');

import 'moment/moment.js';
import vueMoment from 'vue-moment';
require('moment/locale/fr');
Vue.use(vueMoment);


import VuexStoreDefault from './store/default.js';
import VuexStoreMeta from './store/meta.js';

import routerConfig from './router';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import Vuex from 'vuex';
import VueYouTubeEmbed from 'vue-youtube-embed';
import { TableComponent, TableColumn } from 'vue-table-component';
import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/fr';
Vue.use(Element, {locale});

import PageLogin from './components/page/login.vue';

import 'element-ui/lib/theme-chalk/index.css';
import ConcreteStore from 'fundation-app-vuejs/src/concretejs/store';

import Fundation from 'fundation-app-vuejs';
import {Router, Store, I18n} from 'fundation-app-vuejs';
import App from './App.vue'
import EventBus from './eventBus.js';

Vue.prototype.$eventBus = EventBus;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueYouTubeEmbed);

Vue.component('table-component', TableComponent);
Vue.component('table-column', TableColumn);

VuexStoreDefault.metaDefinition = VuexStoreMeta;
VuexStoreDefault.apiRootUrl = window.config.api_root_url;

Vue.use(Fundation);
Vue.config.productionTip = false;

/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router: new Router(routerConfig),
    store: new Store(VuexStoreDefault),
    components: { App },
    template: '<App/>',
    i18n: new I18n(),
});

function translation(key, context){ return app.$t(key, context);}

app.$store.commit('fundation/SET_TRANSLATION_METHOD', translation);

app.$store.dispatch('fundation/changeLang', {lang: 'fr', i18n: app.$i18n});

window.app = app;



// WEBPACK FOOTER //
// ./src/main.js